@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Programs"
  [gridData]="$gridData()"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/program', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="agreements_count" title="Agreements" filter="numeric" />
  <kendo-grid-column field="total_award_amount" title="Total Award Amount" filter="numeric">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-gridcell-currency-shared [value]="item.total_award_amount" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="total_disbursed_amount" title="Total Disbursed Amount" filter="numeric">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-gridcell-currency-shared [value]="item.total_disbursed_amount" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status" [width]="200">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
